import { render, staticRenderFns } from "./SltpModal.vue?vue&type=template&id=abf44bb0&scoped=true"
import script from "./SltpModal.vue?vue&type=script&lang=js"
export * from "./SltpModal.vue?vue&type=script&lang=js"
import style0 from "./SltpModal.vue?vue&type=style&index=0&id=abf44bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf44bb0",
  null
  
)

export default component.exports